import { orderRepository } from "../repository/OrderRepository";

export const orderService = {
  createOrder: async (data, onSuccess, onError) => {
    orderRepository
      .createOrder(data)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getAllOrders: async (page, onSuccess, onError) => {
    orderRepository
      .findAll(page)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getAllOrdersByStatus: async (status, page, onSuccess, onError) => {
    orderRepository
      .findByStatus(status, page)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getOrderById: async (id, onSuccess, onError) => {
    orderRepository
      .findById(id)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  deleteItemFromOrder: async (orderId, itemId, onSuccess, onError) => {
    orderRepository
      .deleteItemFromOrder(orderId, itemId)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  updateStatus: async (details, onSuccess, onError) => {
    orderRepository
      .updateOrderStatus(details)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },

  deleteOrder: async (orderId, onSuccess, onError) => {
    orderRepository
      .deleteOrder(orderId)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },

  searchOrder: async (query, page, onSuccess, onError) => {
    orderRepository
      .search(query, page)
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getOngoingOrderCount: async (onSuccess, onError) => {
    orderRepository
      .findOngoingOrders()
      .then((res) => {
        onSuccess(res.data.orders.length);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
  getNewOrderCount: async (onSuccess, onError) => {
    orderRepository
      .findNewOrders()
      .then((res) => {
        onSuccess(res.data.orders.length);
      })
      .catch((err) => {
        const status = err.response?.status;
        if (status && onError[status]) {
          onError[status](err.response?.message);
        } else if (onError.default) {
          onError.default(err.message);
        }
      });
  },
};
